import React, { useState } from "react";
import {
  Button,
  Divider,
  TableAdv,
  PageHeader,
  PageTitle,
} from "../../../../../../components";
import { dateFormator, mapTableRows } from "../../../../../../utils";
import AddH4 from "./LinkedH4/AddH4";

const LinkedH4 = () => {
 const [addh4 ,setAddh4] = useState(false)


  const tableData = [];
  const columns = [
    {
      key: "dependentName",
      label: "Dependent Name",
    },
    {
      key: "documentNumber",
      label: "Document Number",
    },
    {
      key: "ead",
      label: "EAD",
    },
    {
      key: "aNumber",
      label: "A-Number",
    },
    {
      key: "dateIssued",
      label: "Date Issued",
      render: (row) => dateFormator(row.dateIssued, "month-day-year"),
    },
    {
      key: "validFrom",
      label: "Valid From",
      render: (row) => dateFormator(row.validFrom, "month-day-year"),
    },
    {
      key: "status",
      label: "Status",
    },

    {
      key: "expiryDate",
      label: "Expiry Date",
      render: (row) => dateFormator(row.expiryDate, "month-day-year"),
    },
    {
      key: "currentlyActive",
      label: "Currently Active",
    },

    {
      key: "documents",
      label: "Documents",
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex gap-1">
          <Button
            type="icon"
            icon="edit_square"
            color="black"
            variant="text"
            size="xs"
          />
          <Button
            type="icon"
            icon="delete"
            color="black"
            variant="text"
            size="xs"
          />
          <Button
            type="icon"
            icon="link"
            color="black"
            variant="text"
            size="xs"
          />
        </div>
      ),
    },
  ];
  const mappedRows = mapTableRows(tableData, columns);
  return (
    <div>
      <div className="mt-4">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"LINKED H-4"} tag="p" />
            </div>
          }
          RightSection={
            <>
              <Button
                title="add"
                size="sm"
                icon={"ADD"}
                iconPosition={"before"}
                onClick={()=>setAddh4(true)}
              />
            </>
          }
        />
        <Divider />
      </div>
      <div className="my-6">
        <TableAdv tableId={`immigration_h1b_h1bview_linkedh4`} rows={mappedRows} columns={columns} hideToolBar />
      </div>
      <AddH4 isOpen={addh4} onClose={() => setAddh4(false)}/>
    </div>
  );
};

export default LinkedH4;
